import Swiper from 'swiper/bundle';

document.addEventListener("DOMContentLoaded", function () {
    const featuredSlider = document.querySelector('.featured-content__slider');

    if (featuredSlider) {
        const swiper = new Swiper(featuredSlider, {
            slidesPerView: "auto",
            freeMode: true
        });
    }
});